import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data32 from '../../data/data32.json'
import ArticleList from '../../Components/ArticleList';

const IndustryNews: React.FC = () => {
    const history = useHistory();


    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>行业动态</h1>
                <ArticleList dataId="32" data={data32 as any} />
            </div>
        } />
    );
};

export default IndustryNews;